import { SaneImage } from 'components/sanity/sane-image';
import { SaneBlockChakra } from 'components/sanity/sane-block';

export function BulletsLeft(props: any) {
  const { image, text, body, icons, background, imageWidth, bulletsProp } =
    props;
  const { richText } = body.filter(
    (text: any) => text.key === 'bulletsLeftDescription'
  )[0];

  const bullets = bulletsProp
    ? bulletsProp
    : [
        {
          id: 1,
          name: text.bulletsLeftFirstHeader,
          description: <p>{text.bulletsLeftFirstBody}</p>,
          icon: icons[0]
        },
        {
          id: 2,
          name: text.bulletsLeftSecondHeader,
          description: <p>{text.bulletsLeftSecondBody}</p>,
          icon: icons[1]
        }
      ];

  return (
    <div className="py-8 overflow-hidden lg:py-14">
      <div className="relative max-w-xl px-4 mx-auto sm:px-6 lg:px-8 lg:max-w-7xl">
        <div className="lg:grid lg:grid-cols-2 lg:gap-8">
          <div>
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              {text.bulletsLeftHeader}
            </h2>
            {richText.map((text: any, index: number) => (
              <div key={index} className="max-w-3xl mt-3 text-lg text-gray-500">
                <SaneBlockChakra blocks={text} />
              </div>
            ))}
            <div className="mt-10 space-y-10">
              {bullets.map((item: any) => (
                <div key={item.id} className="relative">
                  <div>
                    <div className="absolute flex items-center justify-center w-12 h-12 text-white rounded-md bg-clerk-blue">
                      <item.icon className="w-6 h-6" aria-hidden="true" />
                    </div>
                    <h3 className="ml-16 text-xl font-medium leading-6 text-gray-900">
                      {item.name}
                    </h3>
                  </div>
                  <div className="mt-2 ml-16 text-lg text-gray-500">
                    {item.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-center justify-center">
            <div
              className={
                background
                  ? 'my-5 lg:my-0 bg-white rounded-lg shadow-lg'
                  : 'my-5 lg:my-0'
              }
            >
              <div className="m-1 rounded-lg">
                <SaneImage src={image.bulletsLeftImage} width={imageWidth} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
